import * as React from "react";
import { QrReader } from "react-qr-reader";
import { useNavigate } from "react-router-dom";
import { setCurrentStep } from "../Stepper/stepperSlice";
import { useDispatch } from "react-redux";
import NavbarStepper from "../Stepper/NavBarStepper";
import { useParams } from "react-router-dom";
import { useInstallReplacementSmartNodeMutation,useGetIMSSmartnodeQuery, useAddChangeLogMutation } from "../../api/apiSlice";
import { useEffect } from "react";
import { showSuccess, showError } from "../../../Global/notifications/notificationsSlice";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useEditJobCardMutation } from "../../api/apiSlice";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { useStepperStateRestoration } from "../useStepperStateRestoration";
import { parseDeviceQr } from "../parseDeviceQr";
import { useRefusedScan } from "../useRefusedScan";

export default function QRCodeScanReplace() {
  // Stepper state restoration
  useStepperStateRestoration();

  const [
    editJobCard, 
    {
      isSuccess: iseditJobCardSuccess,
      isError: iseditJobCardError,
      error: editJobCardError
    }
  ] = useEditJobCardMutation();


  const [
    installReplacementSmartnode,
    {
      isSuccess: installReplacementSmartnodeSuccess,
      isError: isinstallReplacementSmartnodeError,
      error: installReplacementSmartnodeError,
    },
  ] = useInstallReplacementSmartNodeMutation();

  const [
    addChangeLog,
    {
      isSuccess: addChangeLogSuccess,
      isError: isaddChangeLogError,
      error: addChangeLogError,
    },
  ] = useAddChangeLogMutation();


  const [qrCodeData, setQRCodeData] = React.useState(null);

  const scannedRef = React.useRef(false);
  const sentRef = React.useRef(false);
  const badQrToastRef = React.useRef(false);

  const refusedScan = useRefusedScan();

  // Only called when a scan is refused.
  const resetScan = () => {
    refusedScan.refuse(qrCodeData?.serial_number);
    scannedRef.current = false;
    sentRef.current = false;
    setQRCodeData(null);
  };

  let { job_card_reference_id } = useParams();
  const dispatch = useDispatch();
  let navigate = useNavigate();


 useEffect(() => { dispatch(setCurrentStep(3)); }, []);

 const { data: smartnode, isSuccess: isGetSmartnodeSuccess, isError: isGetSmartnodeError, error: getSmartNodeError } = useGetIMSSmartnodeQuery(
    qrCodeData ? { serial_number: qrCodeData.serial_number, imsi_number: qrCodeData.imsi_number } : skipToken
  );
  useEffect(() => {
    if ( installReplacementSmartnodeSuccess && qrCodeData ) {
      const { serial_number } = qrCodeData;
      const body = {
        serial_number:serial_number,
        change:"Installed as a replacement device, QE to approve",
      };
      addChangeLog({ body: body });
    }
  }, [installReplacementSmartnodeSuccess, job_card_reference_id, qrCodeData]);


  useEffect(() => {
    if ( addChangeLogSuccess  ) {
      const body = {
        state: "DET",
        reference_id: job_card_reference_id,
      };
      editJobCard({ body: body });
    }
  }, [addChangeLogSuccess]);

  useEffect(() => {
    if (isGetSmartnodeSuccess && qrCodeData && !sentRef.current) {
      sentRef.current = true;
      const { serial_number, imsi_number } = qrCodeData;
      installReplacementSmartnode({ body: { serial_number, reference_id: job_card_reference_id, imsi_number } });
    }
  }, [qrCodeData, isGetSmartnodeSuccess]);

  useEffect(() => {
    if (isGetSmartnodeError) {
      dispatch(showError(getSmartNodeError.data?.error || "Device lookup failed"));
      resetScan();
    }
  }, [isGetSmartnodeError]);

  useEffect(() => {
    if (isinstallReplacementSmartnodeError) {
      dispatch(showError(installReplacementSmartnodeError.data?.error || installReplacementSmartnodeError.data?.error_message || "Failed to install replacement device"));
      resetScan();
    }
  }, [isinstallReplacementSmartnodeError]);

  useEffect(() => {
    if (isaddChangeLogError) {
      dispatch(showError(addChangeLogError.data?.error || "Failed to log change"));
      resetScan();
    }
  }, [isaddChangeLogError]);

  useEffect(() => {
    if (iseditJobCardSuccess &&  qrCodeData) {
      navigate(`/installer/${job_card_reference_id}/${qrCodeData.serial_number}/${qrCodeData.imsi_number}/details`);
    }
   
  }, [iseditJobCardSuccess]);


  useEffect(() => {
    if (iseditJobCardError) {
      dispatch(showError(editJobCardError.data.error_message));
      resetScan();
    }
  }, [iseditJobCardError, editJobCardError, dispatch]);

  return (
    <>
      <NavbarStepper />

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 100px)", backgroundColor: "#000", px: 2 }}>
        {/* Viewfinder */}
        <Box sx={{ position: "relative", width: "85vw", height: "85vw", mb: 3 }}>
          {/* Corner brackets */}
          <Box sx={{ position: "absolute", top: 0, left: 0, width: 32, height: 32, borderTop: "3px solid #FDB940", borderLeft: "3px solid #FDB940", borderTopLeftRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", top: 0, right: 0, width: 32, height: 32, borderTop: "3px solid #FDB940", borderRight: "3px solid #FDB940", borderTopRightRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: 0, left: 0, width: 32, height: 32, borderBottom: "3px solid #FDB940", borderLeft: "3px solid #FDB940", borderBottomLeftRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: 0, right: 0, width: 32, height: 32, borderBottom: "3px solid #FDB940", borderRight: "3px solid #FDB940", borderBottomRightRadius: "4px", zIndex: 2, pointerEvents: "none" }} />

          <Box sx={{ width: "100%", height: "100%", overflow: "hidden", "& section": { height: "100% !important", paddingTop: "0 !important" }, "& section > div": { paddingTop: "0 !important", height: "100% !important", position: "relative !important" }, "& video": { objectFit: "cover !important", position: "static !important", width: "100% !important", height: "100% !important" } }}>
            {!qrCodeData && (
              <QrReader
                constraints={{ facingMode: "environment" }}
                onResult={(result) => {
                  if (!result || scannedRef.current) return;
                  const parsed = parseDeviceQr(result.text);
                  if (!parsed) {
                    if (!badQrToastRef.current) {
                      badQrToastRef.current = true;
                      dispatch(showError("Not a Tjommie QR code"));
                      setTimeout(() => { badQrToastRef.current = false; }, 3000);
                    }
                    return;
                  }
                  if (refusedScan.ignore(parsed.serial_number)) return;
                  scannedRef.current = true;
                  setQRCodeData(parsed);
                }}
              />
            )}
          </Box>
        </Box>

        <Typography sx={{ color: "rgba(255,255,255,0.8)", textAlign: "center", fontSize: "0.95rem" }}>
          Scan QR Code of the replacement device being installed.
        </Typography>
      </Box>
    </>
  );
}

